import Skeleton from "react-loading-skeleton";
import axios from "axios";
import fallbackImage from "../../Assets/placeholder.jpg";
import { useSelector, useDispatch } from "react-redux";
import { EMenuActions } from "../../store";
import { useState } from "react";

export default function CategoryBtn({ image, category, id, handleClick, active }) {
  const loadSubCat = useSelector((state) => state.EMenu.loadSubCat);
  const C_URL = useSelector((state) => state.Company.c_url);
  const auth_token = useSelector((state) => state.Company.auth_token);
  const m_id = useSelector((state) => state.Company.m_id);
  const t_id = useSelector((state) => state.Company.t_id);

  // let dispatch = useDispatch();

  // console.log(active);

  const [imageUrl, setImageUrl] = useState(
    `https://${C_URL}/storage/uploads/tenant/${t_id}/category/${image}`
  );

  const handleImageError = () => {
    setImageUrl(fallbackImage);
  };



  return (
    <button className={`${active ? "bg-primary text-white" : "bg-dark/5 text-dark"} hover:bg-primary w-24 rounded-lg py-2 max-sm:py-1 hover:text-white`}>
      {loadSubCat ? (
        <Skeleton height={110} />
      ) : (
        <div className="h-full" onClick={() => handleClick({ id })}>
          <div className="overflow-hidden w-[90%] h-[5.5rem] m-auto object-contain object-center rounded-lg">
            <img
              src={imageUrl}
              className="w-50 h-50 object-contain"
              onError={handleImageError}
              alt={`Category: ${category}`}
            />
          </div>
          <p className="w-[80%] max-sm:w-[90%] m-auto line-clamp-2 text-[12px] font-semibold leading-4">
            {category}
          </p>
        </div>
      )}
    </button>
  );
}
